var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivLista" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacionClose = true
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Crear Solicitud de Baja")]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "icon",
                          staticStyle: {
                            "background-color": "rgb(255, 108, 0)",
                            "border-color": "rgb(255, 108, 0)",
                            "padding-right": "20px",
                            display: "block",
                            margin: "0 0 0 auto",
                            "max-height": "75% !important"
                          },
                          on: {
                            click: function($event) {
                              return _vm.crear()
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "color-blanco",
                              staticStyle: { color: "white" }
                            },
                            [_vm._v("Guardar")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                { attrs: { align: "center" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { md10: "" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "rounded-card" },
                        [
                          _c(
                            "v-form",
                            {
                              ref: "form",
                              staticClass: "col-md-12",
                              attrs: { "lazy-validation": "" }
                            },
                            [
                              _c(
                                "v-container",
                                {
                                  staticStyle: {
                                    padding: "30px 40px 50px 40px"
                                  },
                                  attrs: { "grid-list-md": "" }
                                },
                                [
                                  _c(
                                    "FormFieldsContainer",
                                    {
                                      attrs: { titulo: "Información General" }
                                    },
                                    [
                                      _vm._t("prependInformacionGeneral"),
                                      _c(
                                        "v-flex",
                                        { attrs: { x4: "", sm4: "", md4: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                _vm.formFields.numero.label,
                                              disabled: _vm.modoVer
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.numero.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.numero,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.numero.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.formFields.fecha.label,
                                              disabled: _vm.modoVer
                                            },
                                            model: {
                                              value: _vm.formFields.fecha.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.fecha,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.fecha.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                _vm.formFields.usuario.label,
                                              disabled: _vm.modoVer
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.usuario.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.usuario,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.usuario.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                _vm.formFields.simserienumero
                                                  .label
                                            },
                                            on: { change: _vm.mostrarserie },
                                            model: {
                                              value:
                                                _vm.formFields.simserienumero
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.simserienumero,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.simserienumero.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                _vm.formFields.estadoalta.label,
                                              disabled: _vm.modoVer
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.estadoalta.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.estadoalta,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.estadoalta.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                _vm.formFields.estadoactual
                                                  .label,
                                              disabled: _vm.modoVer
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.estadoactual
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.estadoactual,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.estadoactual.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.formFields.telco.label,
                                              disabled: _vm.modoVer
                                            },
                                            model: {
                                              value: _vm.formFields.telco.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.telco,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.telco.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                _vm.formFields.telcoplan.label,
                                              disabled: _vm.modoVer
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.telcoplan.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.telcoplan,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.telcoplan.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" }
                                        },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              label:
                                                _vm.formFields.motibaja.label,
                                              items: _vm.bajalist,
                                              "item-text": "motiname",
                                              "item-value": "motiid",
                                              clearable: ""
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.motibaja.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.motibaja,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.motibaja.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                _vm.formFields.observacion.label
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.observacion
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.observacion,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.observacion.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.crear.titulo", {
            entidad: "La solicitud de baja"
          }),
          mensaje: _vm.mensajeConfirmacionInactivo,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.crear.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }